var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 12.6689L7.66592 14.0028L6.33203 15.3367",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66622 14.0024H3.66455",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3321 14.5188C12.8257 13.9511 14.6855 11.8654 14.9651 9.32336C15.2446 6.78129 13.8825 4.34134 11.5718 3.24529C9.26121 2.14924 6.50985 2.63793 4.718 4.46264C2.92616 6.28735 2.48755 9.04715 3.62542 11.3375",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 6.66206V5.99512",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 10.6631V11.33",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84345 10.1876C8.01484 10.4802 8.32743 10.661 8.66646 10.6638H9.4001C9.88058 10.676 10.2918 10.3214 10.3504 9.84432C10.409 9.36728 10.096 8.92366 9.62686 8.81906L8.37701 8.50493C7.91351 8.39632 7.60593 7.95639 7.66307 7.48378C7.7202 7.01116 8.12374 6.6572 8.59977 6.66216H9.33341C9.67275 6.66446 9.98577 6.84542 10.1571 7.13836",
    stroke: "#653494",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIconOne);
export default __webpack_public_path__ + "static/media/timeline-icon-one.20b521c89efc6c067877f61f1ef0ab7a.svg";
export { ForwardRef as ReactComponent };